import { withLatestFrom, map } from 'rxjs/operators';
import { zip } from 'rxjs';

/**
 * @param {Observable<Playback>}
 * @param {Observable<ResumePoints>}
 * @param {Observable<Config>}
 * @param {Observable<Asset>}
 * @returns {Observable<[Playback, ResumePoints, Config, Asset]>}
 */

const flattenStream = ([[[latestPlayback, latestResumePoints], latestConfig], latestAsset]) =>
    [latestPlayback, latestResumePoints, latestConfig, latestAsset];

const createPlayerLoadStream = (
    playbackUpdate$,
    resumePointsUpdate$,
    configUpdate$,
    assetUpdate$
) =>
    zip(
        playbackUpdate$,
        resumePointsUpdate$,
    )
        .pipe(
            withLatestFrom(configUpdate$),
            withLatestFrom(assetUpdate$),
            map(flattenStream)
        );

export {
    flattenStream,
    createPlayerLoadStream as default,
};

